import { useCallback, useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import APIFilterPopup from "../../../common/APIFilters/FilterPopup";
import { debounce, useQuery } from "../../../utils/common";
import { readFilterQueryParams, updateQueryParamsForTickets } from "../../../utils/filter";
import { ticketFilterSchema } from "../TicketTable";
import { defaultPage, defaultRowsPerPage, } from '../TicketController';
import Menus from "../../../common/Menus";
import { SimpleButton } from "../../../common/Buttons/SimpleButton";
import { getServiceRequestFilterList } from "../../../actions/service_request";
import { useDispatch } from "react-redux";

const ProjectFilter = ({ activeTab }) => {
    const [filterList, setFilterList] = useState({});
    const [isFilterActive, setIsFilterActive] = useState(false);
    const serviceRequestFilterList = useSelector((state) => state.serviceRequest.serviceRequestFilterList);
    const isTicketFilterListLoading = useSelector((state) => state.loading.isTicketFilterListLoading);
    const [filterQueryObject, setFilterObject] = useState({});

    const query = useQuery();
    const limit = parseInt(query.get('limit'), 10);
    const searchQueryParam = query.get('query');
    const navigate = useNavigate();
    const dispatch = useDispatch();

    useEffect(() => {
        let { queryObject, filterStatus } = readFilterQueryParams(ticketFilterSchema, query);
        setFilterObject(queryObject);
        setIsFilterActive(filterStatus?.[ticketFilterSchema.projects.filterName]);
    }, [query])

    const updateQuery = ({ filterList }) => {
        let updatedFilterList = filterList;
        const totalProjects = filterList?.[ticketFilterSchema.projects.filterName]?.length;
        const selectedProject = filterList?.[ticketFilterSchema.projects.filterName]?.filter((project) => project.isSelected)?.length;
        if (selectedProject === 0 || selectedProject === totalProjects) {
            delete updatedFilterList[ticketFilterSchema.issueCategories.filterName];
        }

        updateQueryParamsForTickets({
            navigate,
            destinationTab: activeTab,
            limit,
            page: 1,
            filterList: updatedFilterList,
            filterSchema: ticketFilterSchema,
            query: searchQueryParam,
            defaultRowsPerPage,
            defaultPage,
        });
    };

    const triggerRender = ({ onClick }) => (
        <SimpleButton
            onClick={onClick}
            textOrComponent={'Project'}
            buttonIconComponent={<span className={`material-icons-outlined text-font14 mr-1 }`}>style</span>}
            btnClass={`whitespace-nowrap px-4 py-2 bg-white font-medium text-font11 flex items-center justify-center rounded-5px border hover:bg-scogolightblue ${isFilterActive ? 'text-scogoorange border-scogoorange' : 'hover:text-scogoorange hover:border-scogoorange border-scogoprimary text-scogoprimary'}`}
        />
    );


    const getFilterList = useCallback(({ filter_labels = 'projects,district,locality,state,city,pin,WAREHOUSE_OWNER,CLUSTER,SP,SP,SCM,FE,PM,PSP,SUPERVISOR,REQUESTER,REMOTE_SUPPORT,org,enduser', project_ids, q = '', formName }) => {
        dispatch(getServiceRequestFilterList({ filter_labels, project_ids, q, formName }));
    }, [dispatch])

    const searchFilterList = useMemo(() =>
        debounce((key, filter_label) => {
            if (key && filter_label) {
                getFilterList({ q: key, filter_labels: filter_label, formName: `filter_${filter_label}` })
            }
        }),
        [getFilterList], []);

    return <div className="flex gap-2">
        {isFilterActive && <ProjectList list={filterList?.[ticketFilterSchema.projects.filterName]} />}
        <APIFilterPopup
            triggerRender={triggerRender}
            filterList={filterList}
            setFilterList={setFilterList}
            keysToFilter={[ticketFilterSchema.projects]}
            submit={({ filterList: fl }) => updateQuery({ filterList: fl })}
            filtersData={serviceRequestFilterList}
            filterSchema={ticketFilterSchema}
            filterQueryObject={filterQueryObject}
            isLoading={isTicketFilterListLoading}
            filtersActiveStatus={{ [ticketFilterSchema.projects.filterName]: isFilterActive }}
            onSearch={searchFilterList}
        />
    </div>
}

const ProjectList = ({ list }) => {
    const filteredList = list?.filter(project => project.isSelected);
    const { showTicketSideDrawer } = useSelector((state) => state.tickets);
    const maxNum = showTicketSideDrawer ? 1 : 4;

    const viewAllLabel = () => (
        <Menus
            menuButtonIcon={<span className='text-font12 font-normal text-scogoorange cursor-pointer hover:text-scogobgsky'>
                +{filteredList.length - maxNum}
            </span>}
            itemsClassName={'origin-top-right absolute px-3 py-2  lg:top-0 top-4 mt-2 w-auto z-10 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none'}
            itemLable={filteredList?.slice(maxNum, filteredList.length)?.map(project => project.displayValue)}
            itemClassName={'bg-tagbg block mt-1 scogoprimary text-font11 px-p-6 py-p-3 rounded-3px'}
        />
    );

    return <div className="flex gap-2 items-center">
        {filteredList?.slice(0, maxNum)?.map(project => (
            <div
                title={project.displayValue}
                key={project.apiValue}
                className={`bg-tagbg scogoprimary 2xl:text-font11 text-font10 px-2 py-1 rounded-3px max-w-[10rem] whitespace-nowrap text-ellipsis overflow-hidden `}
            >
                {project.displayValue}
            </div>
        ))}
        {filteredList?.length > maxNum && viewAllLabel()}
    </div>
}

export default ProjectFilter;